// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2GuPL","insightsList":"newBusinessInsightsMenu_insightsList__2EZQg","active":"newBusinessInsightsMenu_active__X7Rnq"};